import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, {Component} from 'react';
import { createRoot } from 'react-dom/client';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

import {applyMiddleware, legacy_createStore as createStore} from 'redux';
import {Provider} from 'react-redux';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import rootReducer from './reducers';

import Axios from 'axios';
import MainLayout from './layouts/MainLayout';
import Analytics from './layouts/Analytics';
import Data from './layouts/Data';
import Login from './layouts/Login';
import SettingsLayout from './layouts/SettingsLayout';
import AccountInfoLayout from './layouts/AccountInfoLayout';
import urlList from './reducers/propertiesReducer';
import getAxiosConfig from './utils/axiosConfig';
import history from './history';

import * as serviceWorker from './serviceWorker';

import './index.scss';
import Logics from "./layouts/Logics";
import Detail from "./components/Channel/API/Logics/Detail";
import ConnectedIntlProvider from "./layouts/ConnectedIntlProvider";
import Segmentations from "./layouts/Segmentations";

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk))); // create store

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: localStorage.getItem('user')
        };
        this.onChangeUser = this.onChangeUser.bind(this);
    }

    onChangeUser(user) {
        this.setState({
            user: user
        });
        localStorage.setItem('user', user);
    }

    async isTokenValid() {
        await Axios.get(`${urlList().baseApiURL}`, getAxiosConfig()).then((response) => {
            if (response.status === 200) {
                if (response.headers.authorization) {
                    localStorage.setItem('token', response.headers.authorization);
                }
                return true;
            }
            return false;
        }).catch((error) => {
            if (error.response && error.response.status === 403)
                localStorage.removeItem("token");
            return false;
        })
    }

    getTokenInformation() {
        let bearerToken = localStorage.getItem(`token`);
        bearerToken = bearerToken.replace('Bearer ', '');

        const bearerTokenInformation = bearerToken.substring(bearerToken.indexOf('.') + 1, bearerToken.lastIndexOf('.'));
        const decoded = atob(bearerTokenInformation);
        return JSON.parse(decoded);
    }

    isAdmin() {
        const role = this.getTokenInformation().rol;
        return role != null && role.toString().includes('ADMIN');
    }

    getPrivileges() {
       return (this.getTokenInformation() !=null && this.getTokenInformation().privileges !=null)? JSON.parse(this.getTokenInformation().privileges):[];
    }

    render() {
        let layout;
        let activeStatus = -1;
        if (localStorage.getItem(`token`) && this.isTokenValid()) {
            activeStatus = this.getTokenInformation().activeStatus;


            if (activeStatus === 1) {
                layout = (
                    <Routes>
                        <Route path="/" element={<MainLayout exact path="/" component={Analytics}  privileges={this.getPrivileges()}/>}/>
                        {/* <MainLayout path="/channels" component={Channels} /> */}
                        <Route path="/analytics" element={<MainLayout path="/analytics" component={Analytics} privileges={this.getPrivileges()}/>}/>
                        <Route path="/segmentations" element={<MainLayout path="/segmentations" component={Segmentations} privileges={this.getPrivileges()}/>}/>
                        <Route path="/logics" element={<MainLayout exact path="/logics" component={Logics} privileges={this.getPrivileges()}/>}/>
                        <Route path="/logics/:logicId" element={<MainLayout path="/logics/:logicId" component={Detail} privileges={this.getPrivileges()}/>}/>
                        <Route path="/logics/:logicId/versions/:versionNumber" element={<MainLayout path="/logics/:logicId/versions/:versionNumber" component={Detail} privileges={this.getPrivileges()}/>}/>
                        <Route path="/data" element ={<MainLayout path="/data" component={Data} privileges={this.getPrivileges()}/>}/>
                        {/* <MainLayout path="/integration" component={Integration} /> */}
                        {/* <MainLayout path="/database" component={Database} /> */}
                        {/* <MainLayout path="/launchpad" component={Launchpad} /> */}
                        {this.isAdmin() && <Route path="/settings" element={<MainLayout path="/settings" component={SettingsLayout} privileges={this.getPrivileges()}/>}/>}
                        {<Route path="/account-info" element={<MainLayout path="/account-info" component={AccountInfoLayout} privileges={this.getPrivileges()}/>}/>}
                    </Routes>
                );
            } else {
                layout = <Routes><Route path="/" element={<MainLayout path="/" component={AccountInfoLayout} privileges={this.getPrivileges()}/>}/></Routes>
            }
        } else {
            layout = <Routes><Route path="*" element={<Login onChangeUser={(user) => this.onChangeUser(user)}/>}/></Routes>
        }

        return (
            <Provider store={store}>
                <Router history={history}>
                    <ConnectedIntlProvider>
                        {layout}
                    </ConnectedIntlProvider>
                </Router>
            </Provider>
        );
    }
}

createRoot(document.getElementById('root')).render(<App />);

serviceWorker.unregister();
